import React from 'react';
import { FaHome, FaUser, FaFileInvoice, FaProductHunt } from 'react-icons/fa';
import { Link } from 'react-router-dom';
import Colors from './Colors';

const Footer = () => {
  return (
    <footer style={styles.footer}>
      <div style={styles.footerContent}>
        <Link to="/index" style={styles.footerItem}>
          <FaHome size={20} />
          <span>Index</span>
        </Link>
        <Link to="/customers" style={styles.footerItem}>
          <FaUser size={20} />
          <span>Customer</span>
        </Link>
        <Link to="/bills" style={styles.footerItem}>
          <FaFileInvoice size={20} />
          <span>Bill</span>
        </Link>
        <Link to="/products" style={styles.footerItem}>
          <FaProductHunt size={20} />
          <span>Product</span>
        </Link>
      </div>
    </footer>
  );
};


const styles = {
  footer: {
    position: 'fixed',
    bottom: 0,
    width: '100%',
    backgroundColor: Colors.primary,
    color: '#fff',
    textAlign: 'center',
    padding: '10px 0',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  footerContent: {
    display: 'flex',
    justifyContent: 'space-around',
    width: '100%',
    padding: '0 20px',
  },
  footerItem: {
    color: '#fff',
    textDecoration: 'none',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    fontSize: '14px',
    margin:'6px',
  },
  footerItemHover: {
    color: '#f0f0f0',
  },
  footerBottom: {
    marginTop: '10px',
    fontSize: '12px',
  },
};

export default Footer;
